export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "¿Cómo voy a recibir el material?",
    answer:
      "Recibes acceso inmediato después de la compra por correo electrónico.",
  },
  {
    question: "¿Puedo usar los GIFs comercialmente?",
    answer:
      "¡Sí! La licencia de uso comercial está incluida. Puedes usar los GIFs para prescribir entrenamientos a tus alumnos, en redes sociales y en cualquier lugar donde los necesites para tu trabajo.",
  },
  {
    question: "¿Funciona para atención online y presencial?",
    answer:
      "Perfectamente. En el online, puedes enviar los GIFs directamente por WhatsApp u otra plataforma. En el presencial, funciona como un apoyo visual rápido para el alumno.",
  },
  {
    question: "¿El acceso es realmente vitalicio?",
    answer:
      "Sí, el pago es único y el acceso es tuyo para siempre. Todas las futuras actualizaciones de la biblioteca de GIFs también estarán incluidas sin costo adicional.",
  },
  {
    question: "¿Necesito algún programa específico?",
    answer:
      "No. Los GIFs son archivos de imagen comunes (.gif) y las planillas son compatibles con Excel y Google Sheets. Puedes usarlos en cualquier celular o computadora.",
  },
];
